import { getApiResponseData } from '../rxjs/get-api-response-data';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
export class UserProfileService {
    constructor(http) {
        this.http = http;
    }
    getSession() {
        return this.http.get(`/api/profile/getsession`).pipe(getApiResponseData());
    }
    assumeIdentity(body) {
        return this.http.post(`/api/profile/assumeidentity`, body).pipe(getApiResponseData());
    }
    getAllowedClaimsPreAuth() {
        return this.http.get(`/api/profile/allowedClaimsPreAuth`).pipe(getApiResponseData());
    }
    changePasswordRequest(request) {
        return this.http
            .post('/api/profile/change-password/request', request)
            .pipe(getApiResponseData());
    }
    changePasswordChange(request) {
        return this.http.post('/api/profile/change-password/change', request).pipe(getApiResponseData());
    }
    associateContract(request) {
        return this.http.post(`/api/profile/associatecontract`, request).pipe(getApiResponseData());
    }
    unassociateContract(request) {
        return this.http.post(`/api/profile/unassociatecontract`, request).pipe(getApiResponseData());
    }
    updateDealerLogo(request) {
        return this.http.post(`/api/profile/updatedealerlogo`, request).pipe(getApiResponseData());
    }
    updateProfilePassword(request) {
        return this.http.patch(`/api/profile/updateprofilepassword`, request).pipe(getApiResponseData());
    }
    sendPushNotification(request) {
        return this.http.put(`/api/profile/sendpushnotification`, request).pipe(getApiResponseData());
    }
}
UserProfileService.ɵfac = function UserProfileService_Factory(t) { return new (t || UserProfileService)(i0.ɵɵinject(i1.HttpClient)); };
UserProfileService.ɵprov = i0.ɵɵdefineInjectable({ token: UserProfileService, factory: UserProfileService.ɵfac, providedIn: 'root' });
//# sourceMappingURL=user-profile.service.js.map